import React from 'react';
import { tariffPriceWithDiscount } from '@src/domains/tariffs';
import { CurrentPrice, OldPriceLine, PriceStack, SinglePrice } from './styles';
import type { TariffPriceLineProps } from './types';

const TariffPriceLine = ({
  priceFormatted,
  oldPriceFormatted,
  packageDiscount,
  priceFromLabel,
  isRepricing,
  updatingLabel,
}: TariffPriceLineProps) => {
  if (isRepricing) {
    return <SinglePrice aria-busy='true'>{updatingLabel}</SinglePrice>;
  }

  const hasOldPrice = !!oldPriceFormatted && !packageDiscount;
  const hasPackageDiscount = !!packageDiscount;
  const isStacked = hasOldPrice || hasPackageDiscount;

  if (!isStacked) {
    return <SinglePrice>{priceFormatted}</SinglePrice>;
  }

  const fromValue = hasOldPrice ? oldPriceFormatted : priceFormatted;
  const toValue = hasPackageDiscount ? tariffPriceWithDiscount(priceFormatted, packageDiscount) : priceFormatted;

  return (
    <PriceStack>
      <OldPriceLine>
        {priceFromLabel} {fromValue}
      </OldPriceLine>
      <CurrentPrice>{toValue}</CurrentPrice>
    </PriceStack>
  );
};

export default TariffPriceLine;
